import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BusinessUnits, InternationalPayments } from '@emburse/embark-complex';
import { Button, useSnackbar } from '@emburse/embark-core';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { createPaymentsGatewaySettlementAccount, syncPaymentsGatewaySettlementAccount } from '../../api/paymentsGatewayFundingSource';
import { $t } from '../../hooks/useTranslation';
import useLoadingOverlay from '../../hooks/useLoadingOverlay';
const PaymentsGatewayAddBankAccount = forwardRef((props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [address, setAddress] = useState();
    const [modalSettings, setModalSettings] = useState();
    const { enqueueSnackbar } = useSnackbar();
    const { applyLoadingState, removeLoadingState } = useLoadingOverlay();
    const handleModalCallback = useCallback((modalOutput) => {
        // eslint-disable-next-line no-param-reassign
        modalOutput.address.postalCode = modalOutput.address.zip;
        createPaymentsGatewaySettlementAccount(modalOutput)
            .then(async (response) => {
            const settlementAccountId = await response.json();
            const syncResponse = await syncPaymentsGatewaySettlementAccount(settlementAccountId);
            if (syncResponse.status < 300) {
                enqueueSnackbar($t('Bank account synchronized successfully.'), {
                    variant: 'alert',
                    AlertProps: { severity: 'success' }
                });
                props.onModalClosed();
            }
            else {
                enqueueSnackbar($t('An error occurred while syncing the bank account information'), { variant: 'alert', AlertProps: { severity: 'error' } });
            }
        })
            .finally(() => {
            removeLoadingState();
        });
    }, [enqueueSnackbar, props, removeLoadingState]);
    const modalSuccessCallBack = (response) => {
        enqueueSnackbar($t('Synchronizing Bank Account with Wise...'), {
            variant: 'alert',
            AlertProps: { severity: 'warning' }
        });
        applyLoadingState();
        handleModalCallback(response);
        return {};
    };
    const modalCloseCallBack = () => {
        setModalOpen(false);
        return {};
    };
    const initialize = useCallback(async () => {
        if (props.Address) {
            setAddress({
                addressLine1: props.Address.addressLine1,
                city: props.Address.city,
                state: props.Address.state,
                country: props.Address.country,
                zip: props.Address.postalCode
            });
        }
        setModalSettings(props);
    }, [props]);
    useEffect(() => {
        initialize();
    }, [initialize]);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { size: "large", onClick: () => setModalOpen(true), "data-qa": "add-bank-component-button", children: "Add Bank Account" }), _jsx(InternationalPayments, { accessToken: modalSettings?.AccessToken || props?.AccessToken, accountHolderName: modalSettings?.AccountHolderName || props?.AccountHolderName, address: address, businessUnit: BusinessUnits.Certify, customerId: modalSettings?.ProcessorSettings?.CustomerId ||
                    props?.ProcessorSettings?.CustomerId, closeCallBack: modalCloseCallBack, environment: modalSettings?.Environment || props?.Environment, modalOpen: modalOpen, platformVersion: modalSettings?.PlatformVersion || props?.PlatformVersion, sourceCurrency: modalSettings?.SourceCurrency || props?.SourceCurrency, successCallBack: modalSuccessCallBack, targetAmount: modalSettings?.TargetAmount || props?.TargetAmount, targetCurrencies: modalSettings?.TargetCurrencies || props?.TargetCurrencies, "data-qa": "add-bank-component-modal" })] }));
});
export default PaymentsGatewayAddBankAccount;
